<p-card header="Piece Rate Week Status" >
  <div class="p-grid">
    <div class="p-col centered">
      <h4>Week Ending {{ saturdayDate | dateTimeToFormat: 'MM/dd/yyyy' }}</h4>
      <h2 *ngIf="!weekIsClosed"><p-message severity="success" text="Open"></p-message></h2>
      <h2 *ngIf="weekIsClosed"><p-message severity="warn" text="Closed"></p-message></h2>
      <button pButton type="button"
        [disabled]="weekIsLocked || loadingIndicator"
        [icon]="loadingIndicator ? 'pi pi-spin pi-spinner' : (weekIsClosed ? 'pi pi-lock-open' : 'pi pi-lock')"
        (click)="checkWeekStatus();"
        [label]="weekIsLocked ? 'Week Locked' : (weekIsClosed ? 'Open' : 'Close')"
        [ngClass]="{ 'p-button-success' : weekIsClosed }">
      </button>
      <br><br>
      <button pButton type="button"
        [disabled]="loadingIndicatorWT"
        [icon]="loadingIndicatorWT ? 'pi pi-spin pi-spinner' :'pi pi-list'"
        (click)="checkWeeklyTotals();"
        [label]="'View Weekly Totals'"
        class="p-button-info">
      </button>
    </div>
  </div>
</p-card>

<p-dialog header="Close Piece   Rate" [(visible)]="warningsVisible" [modal]="true" appendTo="body">
  <p>Are you sure you want to close the week ending {{ saturdayDate | dateTimeToFormat:'MM/dd/yyyy' }}?</p>
  <ul class="bulleted">
    <li *ngFor="let warning of warnings">{{ warning }}</li>
  </ul>
  <p-footer>
    <button pButton class="p-button-info" label="Cancel" (click)="cancelCloseWeekDialog()"></button>
    <button pButton label="Close Week" (click)="toggleSiteWeekClosed()"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Weekly Totals" [(visible)]="weeklyTotalsVisible" [modal]="true" appendTo="body">
  <div class="weeklyTotalsTable">
    <p-table [value]="weeklyTotalItems" dataKey="id" [paginator]="true" [rows]="15">
      <ng-template pTemplate="header">
        <tr>
          <th class="thWidth">Site</th>
          <th class="thWidth">Total Builder Repairs</th>
          <th class="thWidth">Inv. Repairs Incl. Not Pimmed</th>
          <th class="thWidth">PerBuilder Adjustment</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
        <tr>
          <td>
            {{rowData.siteDisplayName}}
          </td>
          <td>
            {{rowData.enteredBuilderRepairs}}
          </td>
          <td>
            {{rowData.inventoryRepairs}}
          </td>
          <td>
            {{rowData.totalAdjustment}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="4" class="centered">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-footer>
    <button pButton label="Close" (click)="closeWeeklyTotalsDialog()"></button>
  </p-footer>
</p-dialog>
